import $ from 'jquery';
import Quote from './Quote';
import Handlebars from '../../common/templates';
import EventBus from '../../common/EventBus';

const SELECTORS = {
  mobileMessageBox: '.v2-booking-floating-footer-message',
  basketMessageBox: '.quote-message',
};

const TEMPLATES = {
  quoteUnavailableBasket: '#quote-unavailable-basket-message-template',
  quoteUnavailableFooter: '#quote-unavailable-footer-message-template',
  unquotedItemsBasket: '#unquoted-items-basket-message-template',
  unquotedItemsFooter: '#unquoted-items-footer-message-template',
  unquotedPartsBasket: '#unquoted-parts-basket-message-template',
  unquotedPartsFooter: '#unquoted-parts-footer-message-template',
  allPartsUnquotedBasket: '#all-parts-unquoted-basket-message-template',
  allPartsUnquotedFooter: '#all-parts-unquoted-footer-message-template',
};

export default class QuoteMessage {
  constructor(data) {
    this.data = data;
    this.quote = data ? new Quote(data) : null;
    this.mobileMessageBox = $(SELECTORS.mobileMessageBox);
    this.basketMessageBox = $(SELECTORS.basketMessageBox);
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    EventBus.on('quote:updated', (eventData) => {
      this.data = eventData.quote;
      this.quote = new Quote(this.data);
      this.update();
    });
  }

  update() {
    if (!this.data) {
      return;
    }

    this._clearMessages();

    if (this.data.promotion_removed_message) {
      this._renderPromotionRemovedMessage(this.data.promotion_removed_message);
    }

    if (this.data.quote_availability === 'not available') {
      this._renderQuoteUnavailableMessage(this.data.quote_request_url);
      return;
    }

    if (this.data.unquoted_items) {
      this._renderUnquotedItemsMessage(this.data.quote_request_url, this.data.unquoted_items);
    }

    if (this.quote.unquotedParts().length > 0) {
      if (this.quote.quotedParts().length > 0) {
        this._renderUnquotedPartsMessage();
      } else {
        this._renderAllPartsUnquotedMessage();
      }
    }
  }

  _clearMessages() {
    this.mobileMessageBox.empty();
    this.basketMessageBox.empty();
  }

  _renderQuoteUnavailableMessage(quoteRequestUrl) {
    const templateData = { quote_request_url: quoteRequestUrl };
    this._renderBasketMessage(TEMPLATES.quoteUnavailableBasket, templateData);
    this._renderFooterMessage(TEMPLATES.quoteUnavailableFooter, templateData);
  }

  _renderUnquotedItemsMessage(quoteRequestUrl, unquotedItems) {
    const templateData = { quote_request_url: quoteRequestUrl, unquoted_items: unquotedItems };
    this._renderBasketMessage(TEMPLATES.unquotedItemsBasket, templateData);
    this._renderFooterMessage(TEMPLATES.unquotedItemsFooter, templateData);
  }

  _renderUnquotedPartsMessage() {
    this._renderBasketMessage(TEMPLATES.unquotedPartsBasket, {});
    this._renderFooterMessage(TEMPLATES.unquotedPartsFooter, {});
  }

  _renderAllPartsUnquotedMessage() {
    this._renderBasketMessage(TEMPLATES.allPartsUnquotedBasket, {});
    this._renderFooterMessage(TEMPLATES.allPartsUnquotedFooter, {});
  }

  _renderPromotionRemovedMessage(message) {
    this.basketMessageBox.append(this._promotionRemovedNotice(message, 'alert-warning'));
    this.mobileMessageBox.append(this._promotionRemovedNotice(message, 'max-width-600 margin-auto')).removeClass('hidden');
  }

  _promotionRemovedNotice(message, containerClass) {
    const trigger = $('<i>', { class: 'fa fa-question-circle promotion-removed-reason__icon' }).attr('data-tooltip-text', '');
    const tooltip = $('<span>', {
      class: 'tooltip promotion-removed-reason__tip',
      text: 'A specialised job in your basket is not eligible for discounts.',
    });
    const reason = $('<span>', { class: 'tooltip-wrapper promotion-removed-reason' }).append(trigger, tooltip);

    return $('<div>', { class: containerClass, html: message }).append(' ', reason);
  }

  _renderBasketMessage(template, templateData) {
    const message = Handlebars.getTemplate(template)(templateData);
    this.basketMessageBox.append(message);
  }

  _renderFooterMessage(template, templateData) {
    const message = Handlebars.getTemplate(template)(templateData);
    this.mobileMessageBox.append(message);
    this.mobileMessageBox.removeClass('hidden');
  }
}
